<label for="customRange" class="form-label">Example range</label>
<input type="range" class="form-range" min="0" max="5" step="0.5" value="3.5" id="customRange" />
